import { HTMLAttributeAnchorTarget } from 'react';
import { generateRelativeDateFromUTCTimestamp } from '../../app-kit/helpers/generateRelativeDateFromUTCTimestamp';
import { SearchResult } from '../types';
import { SearchLandingPagePropertyTileProps } from '../components/SearchLandingPagePropertyTile/SearchLandingPagePropertyTile';
import { SourceType } from '../../analytics/click-through-tracking/TrackingSource';

export const mapSearchResultToPropertyTileProps = ({
  result,
  target = '_self',
  excludeLandAndFloorAreaFeatures = false,
}: {
  result: SearchResult;
  target?: HTMLAttributeAnchorTarget;
  excludeLandAndFloorAreaFeatures?: boolean;
}): SearchLandingPagePropertyTileProps => {
  return {
    image: result.imageV2,
    badge: result.badge,
    title: result.priceV2,
    titleExtra: result.soldDate ? generateRelativeDateFromUTCTimestamp(result.soldDate) : null,
    subtitle: result.address,
    path: result.slugV2 ?? result.reaLinkV2 ?? null,
    clickThroughSource: result.clickThroughTracking?.sourceType
      ? {
          ...result.clickThroughTracking,
          sourceType: 'web' as SourceType,
        }
      : null,
    features: excludeLandAndFloorAreaFeatures
      ? result.features
          ?.map((feature) => ({ ...feature, iconName: feature.iconNameV2 }))
          .filter(({ title }) => {
            return title !== 'Land size' && title !== 'Floor area';
          })
      : result.features?.map((feature) => ({ ...feature, iconName: feature.iconNameV2 })),
    target,
  };
};
